var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "composition-block" },
    [
      _vm.compositionData.name !== ""
        ? [
            _c("div", {
              staticClass: "product-name",
              domProps: { textContent: _vm._s(_vm.compositionData.name) }
            }),
            _vm._v(" "),
            _c("hr", { staticClass: "medium m-0" })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "composition-row" }, [
        _c(
          "span",
          { staticClass: "font-weight-bold" },
          [
            _vm.compositionData.isModifiedFood
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("calorie_base_one_dose")) +
                      "\n      "
                  )
                ]
              : [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("calorie_base_daily_dose")) +
                      "\n      "
                  )
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c("span", {
          domProps: { textContent: _vm._s(_vm.compositionData.servingSize) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "composition-row" }, [
        _c("span", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "kaloszlist_adagszama",
              expression: "'kaloszlist_adagszama'"
            }
          ],
          staticClass: "font-weight-bold"
        }),
        _vm._v(" "),
        _c("span", {
          domProps: { textContent: _vm._s(_vm.compositionData.serving) }
        })
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "thick m-0" }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "composition-row d-flex justify-content-between justify-content-between font-weight-bold"
              },
              [
                _c("span", { staticClass: "ingredient-name" }),
                _vm._v(" "),
                _vm.compositionData.isCalorieCheck &&
                (_vm.compositionData.calorie !== "" ||
                  _vm.hasValueInTableDataListColumn("value"))
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "d-flex justify-content-end align-items-center ingredient-amount text-right"
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.compositionData.servingGram)
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.isCalorieCheck &&
                _vm.hasValueInTableDataListColumn("dv")
                  ? _c("span", {
                      staticClass:
                        "ingredient-dv d-flex align-items-center justify-content-end",
                      domProps: { innerHTML: _vm._s(_vm.$t("kaloria_ri")) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.isCalorieCheck100 &&
                (_vm.compositionData.calorie100 !== "" ||
                  _vm.hasValueInTableDataListColumn("value100"))
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "d-flex justify-content-end align-items-center ingredient-amount text-right text-no-wrap"
                      },
                      [
                        _vm._v(
                          "100 " + _vm._s(_vm.compositionData.for100Unitname)
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.isCalorieCheck100 &&
                _vm.hasValueInTableDataListColumn("dv100")
                  ? _c("span", {
                      staticClass:
                        "flex-wrap ml-2 ingredient-dv d-flex align-items-center justify-content-end text-no-wrap",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("kaloria_ri") +
                            " (100 " +
                            _vm.compositionData.for100Unitname +
                            ")"
                        )
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "thin m-0" })
          ]),
          _vm._v(" "),
          _vm.compositionData.isCalorieCheck ||
          _vm.compositionData.isCalorieCheck100
            ? [
                !!_vm.compositionData.calorie ||
                !!_vm.compositionData.calorie100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_kaloria",
                                expression: "'kaloszlist_kaloria'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          (_vm.compositionData.calorie !== "" ||
                            _vm.hasValueInTableDataListColumn("value"))
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end text-right mr-1",
                                domProps: {
                                  innerHTML: _vm._s(_vm.compositionData.calorie)
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.calorie.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          (_vm.compositionData.calorie100 !== "" ||
                            _vm.hasValueInTableDataListColumn("value100"))
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end text-right mr-1",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.calorie100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.calorie
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.fat.value ||
                !!_vm.compositionData.tableDataList.fat.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_zsir",
                                expression: "'kaloszlist_zsir'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fat.value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fat.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fat
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fat.dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.fullFat.value ||
                !!_vm.compositionData.tableDataList.fullFat.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_zsir_telitett",
                                expression: "'kaloszlist_zsir_telitett'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fullFat
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fullFat.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fullFat
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fullFat
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.fullFatSingle.value ||
                !!_vm.compositionData.tableDataList.fullFatSingle.dv ||
                !!_vm.compositionData.tableDataList.fullFatSingle.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_zsir_egyszeres",
                                expression: "'kaloszlist_zsir_egyszeres'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatSingle.value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatSingle.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatSingle.value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatSingle.dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.fullFatMultiple.value ||
                !!_vm.compositionData.tableDataList.fullFatMultiple.dv ||
                !!_vm.compositionData.tableDataList.fullFatMultiple.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_zsir_tobbszoros",
                                expression: "'kaloszlist_zsir_tobbszoros'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatMultiple.value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatMultiple.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatMultiple.value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .fullFatMultiple.dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.transFat.value ||
                !!_vm.compositionData.tableDataList.transFat.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_zsir_transz",
                                expression: "'kaloszlist_zsir_transz'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.transFat
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.transFat
                                      .dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.transFat
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.transFat
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.colesterin.value ||
                !!_vm.compositionData.tableDataList.colesterin.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_koleszterin",
                                expression: "'kaloszlist_koleszterin'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.colesterin
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.colesterin
                                      .dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.colesterin
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.colesterin
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.kalium.value ||
                !!_vm.compositionData.tableDataList.kalium.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_kalium",
                                expression: "'kaloszlist_kalium'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.kalium
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.kalium.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.kalium
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.kalium
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.carb.value ||
                !!_vm.compositionData.tableDataList.carb.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_szenhidrat",
                                expression: "'kaloszlist_szenhidrat'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.carb.value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.carb.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.carb
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.carb.dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.carbNet.value ||
                !!_vm.compositionData.tableDataList.carbNet.dv ||
                !!_vm.compositionData.tableDataList.carbNet.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_netto_szenhidrat",
                                expression: "'kaloszlist_netto_szenhidrat'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.carbNet
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.carbNet.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.carbNet
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.carbNet
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.sugar.value ||
                !!_vm.compositionData.tableDataList.sugar.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_cukor",
                                expression: "'kaloszlist_cukor'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.sugar
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.sugar.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.sugar
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.sugar
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.sugarAlcohol.value ||
                !!_vm.compositionData.tableDataList.sugarAlcohol.dv ||
                !!_vm.compositionData.tableDataList.sugarAlcohol.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_cukor_alkohol",
                                expression: "'kaloszlist_cukor_alkohol'"
                              }
                            ],
                            staticClass: "ingredient-name pl-2"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .sugarAlcohol.value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .sugarAlcohol.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .sugarAlcohol.value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList
                                      .sugarAlcohol.dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.fiber.value ||
                !!_vm.compositionData.tableDataList.fiber.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_rost",
                                expression: "'kaloszlist_rost'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fiber
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fiber.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.fiber
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.fiber
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.compositionData.tableDataList.protein.value ||
                !!_vm.compositionData.tableDataList.protein.value100
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "composition-row d-flex justify-content-between font-weight-bold"
                        },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "kaloszlist_feherje",
                                expression: "'kaloszlist_feherje'"
                              }
                            ],
                            staticClass: "ingredient-name"
                          }),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("value")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.protein
                                      .value
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck &&
                          _vm.hasValueInTableDataListColumn("dv")
                            ? _c("span", {
                                staticClass: "ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.protein.dv
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("value100")
                            ? _c("span", {
                                staticClass:
                                  "ingredient-amount d-flex align-items-center justify-content-end",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.compositionData.tableDataList.protein
                                      .value100
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.compositionData.isCalorieCheck100 &&
                          _vm.hasValueInTableDataListColumn("dv100")
                            ? _c("span", {
                                staticClass: "ml-2 ingredient-dv text-right",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.compositionData.tableDataList.protein
                                      .dv100
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "thin m-0" }),
                      _vm._v(" "),
                      !!_vm.compositionData.tableDataList.natrium.value ||
                      !!_vm.compositionData.tableDataList.natrium.value100
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "composition-row d-flex justify-content-between font-weight-bold"
                              },
                              [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "kaloszlist_natrium",
                                      expression: "'kaloszlist_natrium'"
                                    }
                                  ],
                                  staticClass: "ingredient-name"
                                }),
                                _vm._v(" "),
                                _vm.compositionData.isCalorieCheck &&
                                _vm.hasValueInTableDataListColumn("value")
                                  ? _c("span", {
                                      staticClass:
                                        "ingredient-amount d-flex align-items-center justify-content-end",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.compositionData.tableDataList
                                            .natrium.value
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.compositionData.isCalorieCheck &&
                                _vm.hasValueInTableDataListColumn("dv")
                                  ? _c("span", {
                                      staticClass: "ingredient-dv text-right",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.compositionData.tableDataList
                                            .natrium.dv
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.compositionData.isCalorieCheck100 &&
                                _vm.hasValueInTableDataListColumn("value100")
                                  ? _c("span", {
                                      staticClass:
                                        "ingredient-amount d-flex align-items-center justify-content-end",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.compositionData.tableDataList
                                            .natrium.value100
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.compositionData.isCalorieCheck100 &&
                                _vm.hasValueInTableDataListColumn("dv100")
                                  ? _c("span", {
                                      staticClass:
                                        "ml-2 ingredient-dv text-right",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.compositionData.tableDataList
                                            .natrium.dv100
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.ingredientList.length !== 0 &&
          _vm.hasValueInTableDataList()
            ? _c("hr", { staticClass: "thick m-0" })
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.ingredientList.length !== 0 &&
          _vm.compositionData.showVitaminHeader
            ? _c(
                "div",
                {
                  staticClass:
                    "composition-row d-flex justify-content-between font-weight-bold"
                },
                [
                  _c(
                    "span",
                    { staticClass: "ingredient-name" },
                    [
                      _vm.compositionData.isModifiedFood
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("calorie_base_other_ingredients")
                                ) +
                                "\n        "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("calorie_base_active_ingredients")
                                ) +
                                "\n        "
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.hasValueInIngredientListColumn("amount")
                    ? [
                        !!_vm.compositionData.servingGram
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "align-items-center d-flex justify-content-end ingredient-amount text-right"
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.compositionData.servingGram
                                    )
                                  }
                                })
                              ]
                            )
                          : _c("span", {
                              staticClass:
                                "align-items-center d-flex justify-content-end ingredient-amount text-right",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.compositionData.servingSize
                                )
                              }
                            })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  (!!_vm.compositionData.servingGram ||
                    !!_vm.compositionData.servingSize) &&
                  _vm.hasValueInIngredientListColumn("rda")
                    ? _c("span", {
                        staticClass:
                          "ingredient-dv d-flex align-items-center justify-content-end",
                        domProps: { innerHTML: _vm._s(_vm.$t("kaloria_nrv")) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.compositionData.ingredientsIn100g &&
                  _vm.hasValueInIngredientListColumn("amount100")
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "align-items-center d-flex justify-content-end ingredient-amount text-right text-no-wrap"
                        },
                        [
                          _vm._v(
                            "100 " + _vm._s(_vm.compositionData.for100Unitname)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.compositionData.ingredientsIn100g &&
                  _vm.hasValueInIngredientListColumn("rda100")
                    ? _c("span", {
                        staticClass:
                          "flex-wrap ml-2 ingredient-dv d-flex align-items-center justify-content-end text-no-wrap",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("kaloria_nrv") +
                              " (100 " +
                              _vm.compositionData.for100Unitname +
                              ")"
                          )
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.ingredientList.length !== 0
            ? _c("hr", { staticClass: "medium m-0" })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.compositionData.ingredientList, function(
            ingredient,
            ingredientIndex
          ) {
            return _c(
              "div",
              {
                key: "ingredient_" + ingredientIndex,
                staticClass: "composition-row d-flex justify-content-between"
              },
              [
                _c("span", {
                  staticClass: "ingredient-name",
                  domProps: { innerHTML: _vm._s(ingredient.name) }
                }),
                _vm._v(" "),
                _vm.hasValueInIngredientListColumn("amount")
                  ? _c("span", {
                      staticClass:
                        "ingredient-amount d-flex align-items-center justify-content-end",
                      domProps: { innerHTML: _vm._s(ingredient.amount) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasValueInIngredientListColumn("rda")
                  ? _c("span", {
                      staticClass: "ingredient-dv text-right",
                      domProps: { innerHTML: _vm._s(ingredient.rda) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.ingredientsIn100g &&
                _vm.hasValueInIngredientListColumn("amount100")
                  ? _c("span", {
                      staticClass:
                        "ingredient-amount d-flex align-items-center justify-content-end",
                      domProps: { innerHTML: _vm._s(ingredient.amount100) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.ingredientsIn100g &&
                _vm.hasValueInIngredientListColumn("rda100")
                  ? _c("span", {
                      staticClass: "ml-2 ingredient-dv text-right",
                      domProps: { innerHTML: _vm._s(ingredient.rda100) }
                    })
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.compositionData.comment !== "" ||
          _vm.compositionData.description !== "" ||
          _vm.compositionData.isCalorieCheck ||
          _vm.compositionData.ingredientList.length !== 0
            ? _c("hr", { staticClass: "thick m-0" })
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.isCalorieCheck &&
          (_vm.compositionData.showRIDescription ||
            _vm.compositionData.showRINote)
            ? _c("div", { staticClass: "comment bottom-text-block" }, [
                _vm.compositionData.showRIDescription
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kaloria_ri_description"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.showRIDescription &&
                _vm.compositionData.showRINote
                  ? _c("br")
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.showRINote
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kaloria_ri_description_note"))
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.ingredientList.length !== 0 &&
          (_vm.compositionData.showNRVDescription ||
            _vm.compositionData.showNRVNote)
            ? _c("div", { staticClass: "comment bottom-text-block" }, [
                _vm.compositionData.showNRVDescription
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kaloria_nrv_description"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.showNRVDescription &&
                _vm.compositionData.showNRVNote
                  ? _c("br")
                  : _vm._e(),
                _vm._v(" "),
                _vm.compositionData.showNRVNote
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("kaloria_nrv_description_note")
                        )
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.description !== ""
            ? _c("div", {
                staticClass: "description bottom-text-block",
                domProps: { innerHTML: _vm._s(_vm.compositionData.description) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.compositionData.comment !== ""
            ? _c("div", {
                staticClass: "comment bottom-text-block",
                domProps: { innerHTML: _vm._s(_vm.compositionData.comment) }
              })
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }